import React from "react";

function Question() {
  return (
    <div className="question bg-cyan-900 relative top-20 w-1/2 py-20 px-10 text-white z-20 animate__animated animate__fadeInLeft ">
      <h5 className="md:text-2xl tracking-widest mb-6" >ABOUT Us</h5>
      <h1 className="font-bold md:text-5xl tracking-wider">What wood is used for house building?</h1>
    </div>
  );
}

export default Question;
